import { Component, OnInit } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ImportExportService } from 'src/app/_services/import-export.service';
import { OnboardService } from "src/app/_services/onboard.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { OnBoardProgressService } from 'src/app/_services/on-board-progress.service';
import { Router } from "@angular/router";

@Component({
    selector: 'app-import-assets',
    templateUrl: './import-assets.component.html',
    styleUrls: ['./import-assets.component.scss'],
    standalone: false
})
export class ImportAssetsComponent implements OnInit {
  translate: any;
  optionsData: any;
  uploadCSVForm: UntypedFormGroup;
  assetKey: string = "assets";
  licenseKey: string;
  lazy:boolean = true;
  stepCompleted: boolean = false;

  constructor(public modalRef: BsModalRef,private languageTranslateService: LanguageTranslateService, 
      private auth: AuthenticationService,private spinner: NgxSpinnerService, 
      private dataExportService: ImportExportService, private onboardService: OnboardService,
      private errorUtil: ErrorUtil,  private progressService: OnBoardProgressService,private route: Router
    ) {
      
    this.uploadCSVForm = new UntypedFormGroup({
      selectedModule: new UntypedFormControl(null, [Validators.required])
    });
             
  }

  ngOnInit(): void {
    
    this.languageTranslateService.wordSrc$.subscribe(transData => { 
        if(Object.keys(transData).length != 0){
          this.translate = transData
        }
    })

    this.optionsData={
      request_headers: {
          "Content-Type": "application/json",
          "Authorization": 'Bearer ' + this.auth.getToken()
      },
      dynamic_list_request_headers: {
          "Content-Type": "application/json",
          "Authorization": 'Bearer ' + this.auth.getToken()
      }
    };

    this.licenseKey = this.dataExportService.getLicenceKeysByModule(this.assetKey)
  }

  loadStarted(result: boolean, data: any) {
    console.log("loadStarted");
    this.spinner.show()
    for (var i in this.uploadCSVForm.controls) {
      this.uploadCSVForm.controls[i].markAsTouched();
      if (this.uploadCSVForm.controls[i].invalid) {
        // console.log('res')
        return false
      }
    }
    this.spinner.hide()
  }

  importerReady(){
    console.log("onReady", this.licenseKey);
    //close event handler of csvbox-button
    this.spinner.hide();
    if (this.stepCompleted){this.modalRef.hide();} //if Asset Import step from onboarding is done
  }

  imported(result: boolean, data: any) {
    if(result) {
      console.log("Sheet uploaded successfully",result);
      console.log(JSON.stringify(data), "data printing");
    
      var newForm = JSON.parse(JSON.stringify(data))
      console.log(newForm['sheet_name'],"===",newForm.sheet_name)
      newForm.sheet_name = this.assetKey
      console.log(newForm)
      this.dataExportService.importCompleted(newForm).subscribe(res => {
        console.log(res, 'res printing in importCompleted')
       //update the steps completion percentage here (if the user Import Assets from onboarding page)
        this.progressService.markStepComplete('import-own-csv-asset');
        this.onSaveStep();
      },
      (error) => {
        console.log(error, 'error callback from importCompleted');
        this.spinner.hide();
        var body = JSON.parse(error._body);
        this.errorUtil.setErrorMessage(400, null, body.detail.title, 'error', 3000);
      });

    }else{
      console.log("There was some problem uploading the sheet", result);
    }
  }

   onSaveStep(){
    let stepObj: any = {onBoardingStep2: true};
    this.onboardService.saveOnboardingSteps(stepObj).subscribe((res: any) => {
      console.log(res)
      if (res.status === 200) {
        this.errorUtil.setErrorMessage(
          200,
          this.translate?.general.messages.savedSuccessfully,
          null,
          "success",
          2000
        );

         this.progressService.sendCurrentStepData(2);
         this.stepCompleted = true;
         this.route.navigate(['/dashboard/onBoard/import-own-csv-jo'])
      }
    },
      (error) => {
        console.log(error);
        this.stepCompleted = false;
        var body = JSON.parse(error._body);
        this.errorUtil.setErrorMessage(400, null, body.detail.title, 'error', 3000);
      }
    );
  }

}
